/**
 * Created by Owner on 2016/10/21.
 * 和值  跨度
 */
import {Component} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {LotteryMath} from "./lotteryMath";
import {MathUtil} from "../../util/mathUtil";

@Component({
  selector: 'lottery-math-hz',
  templateUrl: 'selectMathAndPostion.html',
})
export class LotteryMathHZComponent extends LotteryMathZXFSComponent implements LotteryMath {
  max_place: number = 0;
  btnsOption: any = [];

  ngOnInit() {
    this.selectAreaOption["layout"].forEach(item=> {
      if (item.place > this.max_place) {
        this.max_place = item.place;
      }
    });
  }

  changeTotal() {
    let mname = this.selectAreaOption["mname"];
    let tmpTotal: number = 0;
    let data_sel = this.children.toArray();
    let cc = {};
    let isrx = this.selectAreaOption["isrx"];
    let optionLg = 2;
    let selLenth = this.defaultPosition.length;
    let optionFn = {
      "ZXHZ": ()=> {
        cc = {
          0: 1,
          1: 3,
          2: 6,
          3: 10,
          4: 15,
          5: 21,
          6: 28,
          7: 36,
          8: 45,
          9: 55,
          10: 63,
          11: 69,
          12: 73,
          13: 75,
          14: 75,
          15: 73,
          16: 69,
          17: 63,
          18: 55,
          19: 45,
          20: 36,
          21: 28,
          22: 21,
          23: 15,
          24: 10,
          25: 6,
          26: 3,
          27: 1
        };
        optionLg = 3;
      },
      "ZUHZ": ()=> {
        cc = {
          1: 1,
          2: 2,
          3: 2,
          4: 4,
          5: 5,
          6: 6,
          7: 8,
          8: 10,
          9: 11,
          10: 13,
          11: 14,
          12: 14,
          13: 15,
          14: 15,
          15: 14,
          16: 14,
          17: 13,
          18: 11,
          19: 10,
          20: 8,
          21: 6,
          22: 5,
          23: 4,
          24: 2,
          25: 2,
          26: 1
        };
        optionLg = 3;
      },
      "ZXKD": ()=> {
        cc = {
          0: 10,
          1: 54,
          2: 96,
          3: 126,
          4: 144,
          5: 150,
          6: 144,
          7: 126,
          8: 96,
          9: 54
        };
      },
      "ZXHZ2": ()=> {
        cc = {
          0: 1,
          1: 2,
          2: 3,
          3: 4,
          4: 5,
          5: 6,
          6: 7,
          7: 8,
          8: 9,
          9: 10,
          10: 9,
          11: 8,
          12: 7,
          13: 6,
          14: 5,
          15: 4,
          16: 3,
          17: 2,
          18: 1
        };
        optionLg = 2;
      },
      "ZUHZ2": ()=> {
        cc = {
          0: 0,
          1: 1,
          2: 1,
          3: 2,
          4: 2,
          5: 3,
          6: 3,
          7: 4,
          8: 4,
          9: 5,
          10: 4,
          11: 4,
          12: 3,
          13: 3,
          14: 2,
          15: 2,
          16: 1,
          17: 1,
          18: 0
        };
        optionLg = 2;
      },
      "ZXKD2": ()=> {
        cc = {
          0: 10,
          1: 18,
          2: 16,
          3: 14,
          4: 12,
          5: 10,
          6: 8,
          7: 6,
          8: 4,
          9: 2
        };
      }
    };
    optionFn[mname]();
    for (let i = 0; i <= this.max_place; i++) {
      var s = data_sel[i]["selectNo"].length;
      for (let j = 0; j < s; j++) {
        tmpTotal += cc[parseInt(data_sel[i]["selectNo"][j], 10)]
      }
    }
    if (isrx == 1) {
      tmpTotal *= selLenth == 0 ? 0 : MathUtil.combination(this.lt_position_sel, optionLg);
    }
    this.setTotal(tmpTotal);
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/hz.ts